import { connect } from 'react-redux'
import RiverIceBreakupChart from './RiverIceBreakupChart'
import { makeGetData } from '../selectors/dataSelector'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import getRiverIceDataFromGeoJson from '../utility/getRiverIceDataFromGeoJson'
import TimestampActions from '../redux/timestampRedux'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import convertDateToUTC from '../utility/convertDateToUTC'
import createDateAsUTC from '../utility/createDateAsUTC'

const dataId = 'RiverIceBreakup'
const layerId = 'RiverIceChurchill'
const datetimeId = 'RiverIceChurchill'

// const getISOStringUTC = value => createDateAsUTC(new Date(value)).toISOString()
// const getISOStringUTC = value => convertDateToUTC(new Date(value)).toISOString()
const getISOStringUTC = value => new Date(value).toISOString()

const makeMapStateToProps = () => {
  const getData = makeGetData()
  const getDatetime = makeGetDatetime()

  const mapStateToProps = state => {
    // console.log(state.layer.times)
    return {
      data: getData(state, dataId, getRiverIceDataFromGeoJson),
      timestamp: getDatetime(state, datetimeId, getISOStringUTC) || layerId || '',
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    onClick: (item) =>
      dispatch(
        TimestampActions.setAdvancedTimeRequested(item.datum.timestamp, layerId)
      )
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(RiverIceBreakupChart)



// WEBPACK FOOTER //
// ./src/charts/RiverIceBreakupChartContainer.js